import { hnAPI } from '../../constants/api';
import { pageURL_HN } from '../../constants'
import fetchApi from '../../services/fetch';
import { get } from 'lodash';
import {
    INELIGIBILITY_NOTIFIED,
    SERVICE_AVAILABILITY_DISPLAYED,
    ACTIVATION,
    MESSAGE_DISPLAYED,
    SERVER_RESPONSE_FAILED
} from 'constants/segmentEvents';
import { track, updateGlobalTracker, generateMessageDisplayedSegment, generateServerResponseError } from "utils/segmenTracker";
import axios from 'axios';
import { config } from 'constants/config'
import { getCountry, formatGeocodingParams } from 'utils/utils';

// latitude: 14.081999, 
// longitude: -87.202438,
const initialState = {
    location: [14.07645582, -87.24187379],
    coverage: {},
    offers: {},
    suburb: [],
    permissionError: false
}

export const location = {
    state: { ...initialState },
    reducers: {
        updateLocation(state, payload) {
            return {
                ...state,
                location: payload
            };
        },
        updateCoverage(state, payload) {
            return {
                ...state,
                coverage: { ...state.coverage, ...payload }
            };
        },
        updateOffers(state, payload) {
            return {
                ...state,
                offers: { ...state.offers, ...payload }
            };
        },
        clearLocation(state) {
            return {
                ...state,
                initialState
            }
        },
        resetCoverage(state) {
            return {
                ...state,
                coverage: { ...initialState.coverage }
            };
        },
        resetOffers(state) {
            return {
                ...state,
                offers: { ...initialState.offers }
            };
        },
        updateSuburb(state, payload) {
            return {
                ...state,
                suburb: [...state.suburb, ...payload]
            }
        },
        resetSuburb(state) {
            return {
                ...state,
                suburb: []
            }
        },
        setPermissionStatus(state, payload) {
            return {
                ...state,
                permissionError: payload
            }
        }
    },
    effects: dispatch => {
        return {
            async getCoverage(params) {
                dispatch.apiStatus.setProcessing(true);
                this.resetOffers();
                fetchApi({
                    method: "GET",
                    url: hnAPI.coverage,
                    params
                })
                    .then(response => {
                        this.updateCoverage(response.data);
                        const hasCoverage = get(response, 'data.coverage.hasCoverage', "FALSE");
                        if (hasCoverage === 'TRUE') {
                            updateGlobalTracker({ service_available: true })
                            track(SERVICE_AVAILABILITY_DISPLAYED, { journey: ACTIVATION })
                        }
                        else {
                            track(INELIGIBILITY_NOTIFIED, { journey: ACTIVATION })
                        }
                        dispatch.apiStatus.setProcessing(false);
                    })
                    .catch(error => {
                        this.resetCoverage()
                        dispatch.apiStatus.setRequestFailed({ ...error });
                        track(SERVER_RESPONSE_FAILED, { ...generateServerResponseError(error, ACTIVATION, 'Map', hnAPI.coverage, 'Coverage API') })
                        track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Coverage API') })
                    });
            },
            async getOffers(params) {
                dispatch.apiStatus.setProcessing(true);
                fetchApi({
                    method: "GET",
                    url: hnAPI.offersV2,
                    params: { ...params.queryParams }
                })
                    .then(response => {
                        this.updateOffers(response.data);
                        const productOfferingsList = get(response.data, 'productOfferingsList', [])
                        const navigateURL = productOfferingsList.length ? pageURL_HN.products : pageURL_HN.offerNotAvailable
                        params.callback && params.callback(navigateURL)
                        dispatch.apiStatus.setProcessing(false);
                    })
                    .catch(error => {
                        dispatch.apiStatus.setRequestFailed({ ...error });
                        params.callback && params.callback(pageURL_HN.offerNotAvailable);
                        track(INELIGIBILITY_NOTIFIED, { journey: ACTIVATION })
                        track(SERVER_RESPONSE_FAILED, { ...generateServerResponseError(error, ACTIVATION, 'Map', hnAPI.offers, 'Offers API') })
                        track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Offers API') })

                    });
            },
            async getSuburb(params) {
                this.resetSuburb()
                dispatch.apiStatus.setProcessing(true);
                fetchApi({
                    method: "GET",
                    url: hnAPI.localization,
                    params
                })
                    .then(response => {
                        const localities = get(response, 'data.localities', [])
                        this.updateSuburb(localities);
                        dispatch.apiStatus.setProcessing(false);
                    })
                    .catch(error => {
                        this.resetSuburb()
                        dispatch.apiStatus.setRequestFailed({ ...error });
                        track(SERVER_RESPONSE_FAILED, { ...generateServerResponseError(error, ACTIVATION, 'Input Address', hnAPI.localization, 'Localization API') })
                        track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Localization API') })
                    });
            },

            async getCoordinates({ callback, ...params}) {
                const { latitude, longitude } = config.locations[getCountry()];
                const suburb = formatGeocodingParams(params.suburb['description']);
                const city = formatGeocodingParams(params.city['MUNICIPIO']);
                const department = formatGeocodingParams(params.department['DEPARTAMENTO']);
                const suburbNotGiven = (suburb === "Colonia+no+existe");
                dispatch.apiStatus.setProcessing(true);
                axios({ 
                  method: 'GET',
                  url: `https://maps.googleapis.com/maps/api/geocode/json`,
                  params: {
                    address: suburbNotGiven
                      ? `${city},+${department},+Honduras`
                      : `${suburb},${city},+${department},+Honduras`,
                    key: `${process.env.REACT_APP_GMAP_API_KEY}`,
                  },
                })
                    .then(response => {
                        const results = response?.data.results;
                        const locationData = results.find(item => item.formatted_address.includes(city) && item.formatted_address.includes("Honduras")) ||
                            results.find(item => item.formatted_address.includes(department) && item.formatted_address.includes("Honduras")) ||
                            results.find(item => item.formatted_address.includes("Honduras")) ||
                            results[0] || {};
                        const { lat, lng } = locationData.geometry.location
                        if (lat && lng) {
                            this.updateLocation([lat, lng]);
                            callback && callback()

                        }
                        else {
                            this.updateLocation([latitude, longitude])
                            callback && callback()
                        }
                        dispatch.apiStatus.setProcessing(false);
                    })
                    .catch(err => {
                        this.updateLocation([latitude, longitude]);
                        dispatch.apiStatus.setProcessing(false);
                        callback && callback()
                    })
            }
        };
    }
}

